/* Vila Pure — Daily Calm Duo lander. Zamenjuje Design Canvas runtime:
   akordeon, galerija i drag-scroll rail. Bez zavisnosti. */
(function () {
  var root = document.querySelector('.vp-dc-lander');
  if (!root) return;

  /* --- Akordeon: grid-template-rows 0fr <-> 1fr --- */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[aria-expanded]');
    if (!btn || !root.contains(btn)) return;
    var panel = btn.nextElementSibling;
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.style.gridTemplateRows = open ? '0fr' : '1fr';
    var chev = btn.querySelector('svg');
    if (chev) chev.style.transform = open ? 'rotate(0deg)' : 'rotate(180deg)';
  });

  /* --- Galerija ponude: thumb -> glavna slika --- */
  var gallery = root.querySelector('[data-vp-dc-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-vp-dc-gallery-main]');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-vp-dc-gallery-thumb]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var bg = t.style.backgroundImage;
        if (!bg) return;
        main.style.backgroundImage = bg.replace(/width=\d+/, 'width=1200');
        var label = t.getAttribute('aria-label');
        if (label) main.setAttribute('aria-label', label);
        thumbs.forEach(function (o) {
          o.style.border = o === t
            ? '1.5px solid var(--vp-color-accent)'
            : '1px solid var(--vp-color-border)';
        });
      });
    });
  }

  /* --- "Učitaj još" recenzije --- */
  (function () {
    var btn = root.querySelector('[data-vp-more-reviews]');
    var box = root.querySelector('[data-vp-reviews]');
    if (!btn || !box) return;
    var wrap = btn.parentElement;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var hidden = [].slice.call(box.querySelectorAll('[data-vp-review-more][hidden]'));
      hidden.slice(0, 2).forEach(function (el) { el.hidden = false; });
      if (!box.querySelector('[data-vp-review-more][hidden]')) {
        (wrap || btn).style.display = 'none';
      }
    });
  })();

  /* --- Strelice na rail-u sa sastojcima --- */
  (function () {
    var rail = root.querySelector('[data-vp-ing-rail]');
    if (!rail) return;
    var nudge = function (dir) {
      var railBox = rail.getBoundingClientRect();
      var stops = [].slice.call(rail.children).map(function (k) {
        return k.getBoundingClientRect().left - railBox.left + rail.scrollLeft;
      });
      var target;
      if (dir > 0) {
        target = stops.filter(function (x) { return x > rail.scrollLeft + 8; })[0];
        if (target == null) target = rail.scrollWidth;
      } else {
        var before = stops.filter(function (x) { return x < rail.scrollLeft - 8; });
        target = before.length ? before[before.length - 1] : 0;
      }
      rail.scrollTo({ left: target, behavior: 'smooth' });
    };
    var prev = root.querySelector('[data-vp-ing-prev]');
    var next = root.querySelector('[data-vp-ing-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); nudge(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); nudge(1); });
  })();

  /* --- Drag-to-scroll za .vp-snap rail-ove (miš; touch radi nativno) --- */
  [].slice.call(root.querySelectorAll('.vp-snap')).forEach(function (rail) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = rail.scrollLeft;
      rail.style.cursor = 'grabbing';
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      rail.scrollLeft = startLeft - dx;
    });
    function end() { down = false; rail.style.cursor = 'grab'; }
    rail.addEventListener('pointerup', function (e) {
      if (moved) { e.preventDefault(); rail.addEventListener('click', function k(ev) {
        ev.stopPropagation(); ev.preventDefault(); rail.removeEventListener('click', k, true);
      }, true); }
      end();
    });
    rail.addEventListener('pointerleave', end);
    rail.addEventListener('pointercancel', end);
  });
})();
